import { render, staticRenderFns } from "./MyCheckButton.vue?vue&type=template&id=6d824b52"
import script from "./MyCheckButton.vue?vue&type=script&lang=js"
export * from "./MyCheckButton.vue?vue&type=script&lang=js"
import style0 from "./MyCheckButton.vue?vue&type=style&index=0&id=6d824b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports